import React, { useState, useEffect } from 'react'
import { Button, Grid, Paper, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { usuariosSearchFormFields } from '../../constants/initialConstants'
import { styles } from '../../styles/js/searchForm'
import 'moment/locale/pt-br'

function SearchFormUsuarios(props) {
  const [searchFormState, setSearchFormState] = useState(usuariosSearchFormFields)

  const { 
    classes,
    filter,
    setFilterState,
  } = props

  const {
    nome,
  } = searchFormState

  useEffect(() => {
    if (JSON.stringify(searchFormState) === JSON.stringify(usuariosSearchFormFields)) {
      setFilterState('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFormState])

  const resetSearchFormState = () => {
    setSearchFormState(usuariosSearchFormFields)
    setFilterState('')
  }

  const handleChange = event => {
    setSearchFormState({
      ...searchFormState,
      [event.target.id]: event.target.value
    })
  }

  return (
    <Paper className={classes.paper} elevation={0}>
      <form className={classes.container} noValidate autoComplete="off">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.formSection}>
              <span className={classes.formSectionLabel}>
                Geral
              </span>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    id="nome"
                    label="Nome"
                    className={classes.textField}
                    value={nome}
                    onChange={handleChange}
                    margin="normal"
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>

        <Button 
          onClick={() => filter(searchFormState)} 
          variant="contained" 
          className={classes.filterButton} 
          disabled={JSON.stringify(searchFormState) === JSON.stringify(usuariosSearchFormFields) ? true : false}
        >
          Filtrar
        </Button>
        <Button 
          onClick={resetSearchFormState} 
          variant="contained" 
          className={classes.clearButton} 
          disabled={JSON.stringify(searchFormState) === JSON.stringify(usuariosSearchFormFields) ? true : false}
        >
          Limpar
        </Button>
      </form>
    </Paper>
  )
}

export default withStyles(styles)(SearchFormUsuarios)
